import { useEffect } from 'react';
import Lenis from 'lenis';

/**
 * VAROTRADES — Smooth Scroll wrapper using Lenis
 * - Provides "GPU-smooth" scrolling experience
 * - Disabled on touch devices to preserve native momentum scrolling
 * - Exposes window.__lenis for scroll-driven effects
 */
const SmoothScroll = ({ children }) => {
 useEffect(() => {
 if (typeof window === 'undefined') return;
 if (window.matchMedia('(pointer: coarse)').matches) return; // skip mobile

 const lenis = new Lenis({
 duration: 1.15,
 easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
 smoothWheel: true,
 wheelMultiplier: 1,
 touchMultiplier: 1.4,
 // CRITICAL: skip Lenis hijacking inside any drawer/modal/dialog so native
 // scroll works there (mouse wheel, touch, trackpad). Lenis would otherwise
 // capture wheel events on the window and the scrollable content inside
 // the dialog would not move.
 prevent: (node) => {
   if (!node || typeof node.closest !== 'function') return false;
   return !!(
     node.closest('[data-lenis-prevent]') ||
     node.closest('[role="dialog"]') ||
     node.closest('[data-modal="open"]') ||
     node.closest('[aria-modal="true"]')
   );
 },
 });

 window.__lenis = lenis;

 const raf = (time) => {
 lenis.raf(time);
 requestAnimationFrame(raf);
 };
 requestAnimationFrame(raf);

 return () => {
 lenis.destroy();
 delete window.__lenis;
 };
 }, []);

 return children;
};

export default SmoothScroll;
